import React, {
    useCallback,
    useEffect,
    useLayoutEffect,
    useState,
} from 'react';
import { Option } from '@own/fds-react/dist/types/fm-dropdown.types';
import FMCheckboxInput from '../../../common/fm-checkbox-input/fm-checkbox-input';
import './img-spc-vehicle-service-za.scss';
import { FMButton, FMDropdown } from '@own/fds-react';
import { ImgSpcDealerModelServiceDataZA } from '../img-spc-dealers-model-za/img-spc-dealers-model-za';
import { ImgSpcResultsForDerivativeApiDataData } from '../../../../models/serice-price-calculator-model';
import {
    ImgSpcFieldLabelsContentFragment,
    ImgSpcHeadingContentFragment,
    ImgSpcIolmContentFragment,
    ImgSpcZaContentFragment,
} from '../../../../models/img-service-price-calculator/img-service-price-calculator';
import { useAnalytics } from '../../../../hooks/use-analytics';
import DOMPurify from 'dompurify';

interface ImgSpcVehicleServiceZaProps {
    setImgSpcDealerModelServiceDataZA: React.Dispatch<
        React.SetStateAction<ImgSpcDealerModelServiceDataZA>
    >;
    serviceIntervalDropdownData: Option[];
    imgSpcDealerModelServiceDataZA: ImgSpcDealerModelServiceDataZA;
    handleImgSpcDropdownChange: (
        e: React.ChangeEvent<HTMLSelectElement>
    ) => void;
    imgSpcDerivativeData: ImgSpcResultsForDerivativeApiDataData;
    headersLabel?: ImgSpcHeadingContentFragment;
    fieldsLabel?: ImgSpcFieldLabelsContentFragment;
    iolmLabel?: ImgSpcIolmContentFragment;
    zaLabel?: ImgSpcZaContentFragment;
    timingBeltChecked: boolean;
    onTimingBeltCheckedChange?: (checked: boolean) => void;
    onlyIOLMChecked: boolean;
    onOnlyIOLMCheckedChange?: (checked: boolean) => void;
    oilChangeIOLMChecked: boolean;
    onOilChangeIOLMCheckedChange?: (checked: boolean) => void;
}

const ImgSpcVehicleServiceZa = ({
    setImgSpcDealerModelServiceDataZA,
    serviceIntervalDropdownData,
    imgSpcDealerModelServiceDataZA,
    handleImgSpcDropdownChange,
    imgSpcDerivativeData,
    headersLabel,
    fieldsLabel,
    iolmLabel,
    zaLabel,
    timingBeltChecked,
    onTimingBeltCheckedChange,
    onlyIOLMChecked,
    onOnlyIOLMCheckedChange,
    oilChangeIOLMChecked,
    onOilChangeIOLMCheckedChange,
}: ImgSpcVehicleServiceZaProps) => {
    const [showIOLM, setShowIOLM] = useState(false);
    useLayoutEffect(() => {
        if (
            imgSpcDerivativeData.results[0].iolmJson &&
            Object.values(imgSpcDerivativeData.results[0].iolmJson).length
        ) {
            setShowIOLM(true);
            setImgSpcDealerModelServiceDataZA(prevState => ({
                ...prevState,
                oilChangeIOLM: true,
            }));
        } else {
            setShowIOLM(false);
            setImgSpcDealerModelServiceDataZA(prevState => ({
                ...prevState,
                oilChangeIOLM: false,
            }));
        }
    }, [JSON.stringify(imgSpcDerivativeData)]);

    const [fireEvents] = useAnalytics();

    const handleTimingBeltCheckboxChange = useCallback(
        (checked: boolean) => {
            if (onTimingBeltCheckedChange) {
                onTimingBeltCheckedChange(checked);
            }
        },
        [onTimingBeltCheckedChange]
    );

    const handleOnlyOLMCheckboxChange = useCallback(
        (checked: boolean) => {
            if (onOnlyIOLMCheckedChange) {
                onOnlyIOLMCheckedChange(checked);
            }
        },
        [onOnlyIOLMCheckedChange]
    );

    const handleOilChangeIOLMChange = useCallback(
        (checked: boolean) => {
            if (onOilChangeIOLMCheckedChange) {
                onOilChangeIOLMCheckedChange(checked);
            }
        },
        [onOilChangeIOLMCheckedChange]
    );

    useEffect(() => {
        if (!imgSpcDealerModelServiceDataZA.serviceInterval) {
            if (onOnlyIOLMCheckedChange) onOnlyIOLMCheckedChange(false);
            if (onOilChangeIOLMCheckedChange)
                onOilChangeIOLMCheckedChange(true);
        }
    }, [
        imgSpcDealerModelServiceDataZA.serviceInterval,
        onOnlyIOLMCheckedChange,
        onOilChangeIOLMCheckedChange,
    ]);

    useEffect(() => {
        if (!onlyIOLMChecked) {
            if (onOilChangeIOLMCheckedChange)
                onOilChangeIOLMCheckedChange(true);
            setImgSpcDealerModelServiceDataZA(prevState => ({
                ...prevState,
                serviceInterval: serviceIntervalDropdownData[0]?.value || '',
            }));
        }
    }, [
        onlyIOLMChecked,
        onOilChangeIOLMCheckedChange,
        setImgSpcDealerModelServiceDataZA,
        serviceIntervalDropdownData,
    ]);

    return (
        <section className="img-spc-service-interval">
            <h3 className="service-interval-title">
                {headersLabel?.serviceIntervalTitle}
            </h3>
            {showIOLM ? (
                <FMCheckboxInput
                    label={iolmLabel?.onlyIolm}
                    value="onlyIOLM"
                    name="onlyIOLM"
                    wrapperClassName="checkbox-onlyiolm-wrapper"
                    checked={onlyIOLMChecked}
                    onChange={e =>
                        handleOnlyOLMCheckboxChange(e.target.checked)
                    }
                />
            ) : null}
            {!onlyIOLMChecked ? (
                <>
                    {!imgSpcDealerModelServiceDataZA.onlyIOLM ? (
                        <>
                            <div className="img-spc-service-interval-dropdown">
                                <FMDropdown
                                    header={
                                        fieldsLabel?.selectYourServiceIntervalLabel
                                    }
                                    value={
                                        imgSpcDealerModelServiceDataZA.serviceInterval
                                    }
                                    name="serviceInterval"
                                    onChange={handleImgSpcDropdownChange}
                                    options={serviceIntervalDropdownData}
                                    renderOwnOption={(
                                        options: string[] | Option[]
                                    ) => {
                                        const newOptions = options as Option[];
                                        return (
                                            <>
                                                <option
                                                    value=""
                                                    disabled
                                                    selected
                                                >
                                                    {
                                                        fieldsLabel?.selectYourServiceIntervalPlaceHolderText
                                                    }
                                                </option>
                                                {newOptions.map(option => (
                                                    <option
                                                        key={option.value}
                                                        value={option.value}
                                                    >
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </>
                                        );
                                    }}
                                    placeholder={
                                        fieldsLabel?.selectYourServiceIntervalPlaceHolderText
                                    }
                                    ariaLabel={
                                        fieldsLabel?.selectYourServiceIntervalPlaceHolderText ??
                                        'Please Select Your Service Interval'
                                    }
                                />
                            </div>
                            {imgSpcDerivativeData.results[0]
                                .timingBeltPartDetails ? (
                                <FMCheckboxInput
                                    label={
                                        <>
                                            <span className="timing-belt-part-name">
                                                {
                                                    imgSpcDerivativeData
                                                        .results[0]
                                                        .timingBeltPartDetails[0]
                                                        .PartName
                                                }{' '}
                                                -{' '}
                                            </span>
                                            {
                                                imgSpcDerivativeData.results[0]
                                                    .timingBeltPartDetails[0]
                                                    .MessageEnglish
                                            }
                                        </>
                                    }
                                    value="timingBelt"
                                    name="timingBelt"
                                    wrapperClassName="checkbox-timingbelt-wrapper"
                                    checked={timingBeltChecked}
                                    onChange={e =>
                                        handleTimingBeltCheckboxChange(
                                            e.target.checked
                                        )
                                    }
                                />
                            ) : null}
                            {showIOLM ? (
                                <FMCheckboxInput
                                    label={iolmLabel?.oilChangeDue}
                                    value="oilChangeIOLM"
                                    name="oilChangeIOLM"
                                    wrapperClassName="checkbox-oilchangeiolm-wrapper"
                                    checked={oilChangeIOLMChecked}
                                    onChange={e =>
                                        handleOilChangeIOLMChange(
                                            e.target.checked
                                        )
                                    }
                                />
                            ) : null}
                        </>
                    ) : null}
                </>
            ) : null}
            {showIOLM ? (
                <div
                    className="iolm-disclaimer"
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                            iolmLabel?.descriptionToBeDisplayedForIOLM.html ??
                                ''
                        ),
                    }}
                />
            ) : null}
            <FMButton
                htmlButtonType="submit"
                label={headersLabel?.calculateButtonText}
                type="primary"
                className="img-spc-calculate-button"
                onClick={() => {
                    fireEvents(
                        ['spc-calculate-cta'],
                        undefined,
                        {
                            fieldName: headersLabel?.calculateButtonText,
                        },
                        false
                    );
                }}
            />
            {!imgSpcDealerModelServiceDataZA.onlyIOLM ? (
                <div
                    className="other-disclaimer"
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                            zaLabel?.disclosureDataBelowResult.html ?? ''
                        ),
                    }}
                />
            ) : null}
        </section>
    );
};

export default ImgSpcVehicleServiceZa;
